import React from 'react';
import {classes, style} from './doppe-action-type-content-widget.st.css';
import {DoppeActionGoalType, DoppeActionType} from '../../../client-server-common/doppe-action-types/doppe-action-type';
import {
    DoppeActionTypeWidgetInnerDescription
} from '../../../components/doppe-action-type-widget-inner-description/doppe-action-type-widget-inner-description';
import {
    DoppeActionTypeWidgetInnerTitle
} from '../../../components/doppe-action-type-widget-inner-title/doppe-action-type-widget-inner-title';
import {DoppeActionTypeContent} from '../doppe-action-type-content';
import {arrayFirst, asArray, HtmlObjectResizeMode} from '@wix/devzai-utils-common';
import {DoppePageMediaView} from '../../../components/doppe-page-media-view/doppe-page-media-view';
import {
    DoppeActionTypeWidgetLayout
} from '../../../components/doppe-action-type-widget-layout/doppe-action-type-widget-layout';
import {
    DoppeActionTypeWidgetContentLayoutNewWrapperSectionsAndButtons
} from '../../../components/doppe-action-type-widget-content-layout-new-wrapper-sections-and-buttons/doppe-action-type-widget-content-layout-new-wrapper-sections-and-buttons';
import {IDoppeViewerActionContext} from '../../../doppe-sdk';


export const DoppeActionTypeContentWidget = React.memo(function DoppeActionTypeLinkWidget(
    props: DoppeActionType.WidgetProps<DoppeActionTypeContent.ActionSettings>
) {
    const {
        actionContext,

        className,
        ...htmlAttributes
    } = props;

    return (
        <DoppeActionTypeWidgetLayout
            {...htmlAttributes}
            className={style(classes.root, {}, className)}
            actionContext={actionContext}
        >
            <DoppeActionTypeContentWidgetInner
                actionId={actionContext.action.id}
                actionSettings={actionContext.action.settings}
                actionContext={actionContext}
                reportGoalAchieved={(goalType) => {
                    actionContext.reportGoalAchieved({
                        goalType: goalType,
                    })
                }}
            />
        </DoppeActionTypeWidgetLayout>
    );
});


export const DoppeActionTypeContentWidgetInner = React.memo(function DoppeActionTypeLinkWidgetInner(
    props: {
        actionContext: IDoppeViewerActionContext<DoppeActionTypeContent.ActionSettings>
        actionSettings: DoppeActionTypeContent.ActionSettings;
        actionId: string;
        listItemId?: string;
        reportGoalAchieved: (goalType: DoppeActionGoalType) => void;
    }
) {
    const {
        actionSettings,
        actionContext,
        reportGoalAchieved,
        listItemId
    } = props;

    const {
        description,
        title,
        image,
    } = actionSettings;

    const firstImage = image ? arrayFirst(asArray(image)) : null;

    return (
        <DoppeActionTypeWidgetContentLayoutNewWrapperSectionsAndButtons
            actionContext={actionContext}
            reportGoalAchieved={reportGoalAchieved}
            mainMedia={firstImage ? (
                <div
                    className={style(classes.imageContainer, {})}
                >
                    <DoppePageMediaView
                        className={style(classes.image, {})}
                        mediaResource={firstImage}
                        layoutSpec={{autoHeight: true, maxHeight: 360}}
                        widthSpec={{contentRelativeWidth: 1}}
                        mediaResizeMode={HtmlObjectResizeMode.Cover}
                    />
                </div>
            ) : null}
            sections={actionSettings.sections}
            buttons={actionSettings.ctaButtons}
            buttonsSettings={{
                listItemId: listItemId,
            }}
        >
            <DoppeActionTypeWidgetInnerTitle>
                {title}
            </DoppeActionTypeWidgetInnerTitle>
            <DoppeActionTypeWidgetInnerDescription
                className={style(classes.couponDescription, {})}
                maxLines={10}
            >
                {description}
            </DoppeActionTypeWidgetInnerDescription>
        </DoppeActionTypeWidgetContentLayoutNewWrapperSectionsAndButtons>
    );
});